import { motion, type Variants } from 'motion/react';
import type { PropsWithChildren } from 'react';
import { useNavigationType } from 'react-router';
import { useIsDesktop } from '@/hooks/use-user-platform';
import cn from '@/utils/merge-class-names';

interface Props {
  className?: string;
}

export default function AnimatedLayout({ className, children }: PropsWithChildren<Props>) {
  const isDesktop = useIsDesktop();
  const navigationType = useNavigationType();

  if (isDesktop)
    return (
      <div
        id='page-layout'
        className={className}>
        {children}
      </div>
    );

  return (
    <motion.div
      variants={navigationType === 'REPLACE' ? undefined : stackVariants}
      initial={navigationType === 'PUSH' ? 'initial' : 'exit'}
      animate='enter'
      exit={navigationType === 'PUSH' ? 'exit' : 'initial'}
      className={cn('transition-all duration-[50]', className)}
      id='page-layout'>
      {children}
    </motion.div>
  );
}

const stackVariants: Variants = {
  initial: {
    x: '15vw',
  },
  enter: {
    x: '0vw',
    scale: 1,
  },
  exit: {
    scale: 0.98,
  },
};

const drawerVariants: Variants = {
  initial: {},
  enter: {},
  exit: {},
};
